import SwaggerClient from './SwaggerClient';
import {USERNAME_PASSWORD, USERNAME_PASSWORD_WITH_TOKEN, LDAP, RESTFUL, RADIUS} from './types/login.type';
import {RESET_PASSWORD_SMS, RESET_PASSWORD_SETTING} from './types/resetPassword.type';

export default class SwaggerAuthenClient extends SwaggerClient {
    public async login(query: any = {}) {
        const data: any = {
            type: query.type,
        }
        if (query.domainId) {
            data.domain_id = query.domainId
        }
        data.login_name = query.loginName
        data.password = query.password
        data.otp = query.otp
        data.request_id = query.requestId
        if (query.requested_permissions) {
            data.requested_permissions = query.requested_permissions
        }

        const {body} = await this.execute("Login",
            {body: data},
            {'ctx.domain_id': '@any'})
        return body

    }

    public async prepareLogin(query: any = {}) {
        const data: any = {}

        if (query.type) {
            data.type = query.type
        }

        if (query.expected_mfas) {
            data.expected_mfas = query.expected_mfas
        }

        if (query.forceNewSession) {
            data.force_new_session = query.forceNewSession
        }

        const {body} = await this.execute("PrepareLogin",
            {body: data},
            {'ctx.domain_id': '@any'})

        return body
    }

    public async requestChangePassword(query: any = {}) {
        const parameters = {
            login_name: query.loginName,
            type: ""
        }
        if (query.type) {
            parameters.type = query.type;
        }

        const {body} = await this.execute("RequestChangePassword",
            {body: parameters},
            {'ctx.domain_id': '@any'})

        return body
    }

    public async resetPassword(query: any = {}) {
        const parameters: any = {
            'body': {
                new_password: query.newPassword,
            }
        }

        if (query.domainId && query.token) {
            parameters.body.ctx = {
                domain_id: query.domainId,
                access_token: query.token
            }
        }
        if (query.type === RESET_PASSWORD_SMS) {
            parameters.body.ctx = {access_token: query.token}
            parameters.body.otp = query.otp
        } else if (query.type === RESET_PASSWORD_SETTING) {
            parameters.body.old_password = query.oldPassword
            if (query.loginName) {
                parameters.body.login_name = query.loginName
            }
        } else {
            parameters.body.ctx = {access_token: query.token}
        }
        const {body} = await this.execute("ResetPassword", parameters, {'ctx.domain_id': '@any'})

        return body
    }

    public async getAllMfa() {
        const {body} = await this.execute("MfaGetAllByUser")

        return body
    }

    public async updateMfa(query: any = {}) {
        const parameters: any = {
            'body': {}
        }
        if (query.token) {
            parameters.body.ctx = {
                access_token: query.token
            }
        }
        if (query.type) {
            parameters.type = query.type
            parameters.body.type = query.type
        }
        if (query.data) {
            parameters.body.data = query.data
        }

        function handleErrors(error) {
            throw  JSON.stringify(error)
        }

        const {body} = await this.execute('MfaUpdate', parameters, {'ctx.domain_id': query.domainId}, handleErrors)
        return body
    }

    public async deleteMfa(query: any = {}) {
        const parameters = {
            type: query.type
        }

        const {body} = await this.execute('MfaDelete', parameters)

        return body
    }

    public async getAllLoginSession(query: any = {}) {

    }


    public async logout(query: any = {}) {
        const parameters: any = {}
        if (query.loginSessionId) {
            parameters.login_session_id = query.loginSessionId
        }
        if (query.allDevice) {
            parameters.all_device = query.allDevice
        }
        if (query.exceptCurrentSession) {
            parameters.except_current_session = query.exceptCurrentSession
        }
        const {body} = await this.execute("Logout", {
            body: parameters
        })

        return body
    }

    public async prepareUpdateMfa(query: any = {}) {
        const parameters: any = {
            'body': {}
        }
        if (query.token) {
            parameters.body.ctx = {
                access_token: query.token
            }
        }
        if (query.type) {
            parameters.body.type = query.type
        }
        if (query.data) {
            parameters.body.data = query.data
        }

        function handleErrors(error) {
            throw  JSON.stringify(error)
        }

        const {body} = await this.execute("PrepareUpdateMfa", parameters, {'ctx.domain_id': query.domainId}, handleErrors)

        return body
    }

    public async verifyUpdate(query: any = {}) {
        const parameters: any = {
            'body': {}
        }
        if (query.token) {
            parameters.body.ctx = {
                access_token: query.token
            }
        }
        if (query.request_id) {
            parameters.body.request_id = query.request_id
        }
        if (query.session_id) {
            parameters.body.session_id = query.session_id
        }
        if (query.otp) {
            parameters.body.otp = query.otp
        }
        if (query.type) {
            parameters.body.type = query.type
        }

        function handleErrors(error) {
            throw  JSON.stringify(error)
        }

        const {body} = await this.execute("VerifyUpdateMfa", parameters, {'ctx.domain_id': query.domainId}, handleErrors)

        return body
    }

    public async requestUnlock(query: any = {}) {
        const parameters = {
            body: {
                login_name: query.login_name,
                type: query.type,
                ctx: {
                    domain_id: query.domainId,
                    access_token: query.token
                }
            }
        }


        const {body} = await this.execute("RequestUnlockUser",
            {body: parameters.body},
            {'ctx.domain_id': 'default'}
        )

        return body
    }

    public async requestUnlockOtp(query: any = {}) {
        const parameters: any = {
            'body': {
                otp: query.otp,
                ctx: {
                    access_token: query.token
                }
            }
        }
        const {body} = await this.execute("UnlockUser", parameters, {'ctx.domain_id': '@any'})

        return body
    }
}
